import { createContext, useState } from "react";

export const IsAuthenticatedContext = createContext<
  [boolean, React.Dispatch<React.SetStateAction<boolean>>]
>([true, () => undefined]);

export const IsAuthenticatedProvider: React.FC = ({ children }) => {
  const [isAuthenticated, setAuthenticated] = useState<boolean>(true);
  return (
    <IsAuthenticatedContext.Provider value={[isAuthenticated, setAuthenticated]}>
      {children}
    </IsAuthenticatedContext.Provider>
  );
};

export const CsrfTokenProvider: React.FC = ({ children }) => {
  const [csrfToken, setCsrfToken] = useState<string>("");

  return (
    <CsrfTokenContext.Provider value={[csrfToken, setCsrfToken]}>
      {children}
    </CsrfTokenContext.Provider>
  );
};

export const CsrfTokenContext = createContext<
  [string, React.Dispatch<React.SetStateAction<string>>]
>(["", () => undefined]);

export const passLastUpdatedContext = createContext<
  [boolean, React.Dispatch<React.SetStateAction<boolean>>]
>([true, () => true]);

export const IpassLastUpdatedProvider: React.FC = ({ children }) => {
  const [passwordLastUpdated, setPasslastUpdated] = useState<boolean>(true);
  return (
    <passLastUpdatedContext.Provider value={[passwordLastUpdated, setPasslastUpdated]}>
      {children}
    </passLastUpdatedContext.Provider>
  );
};
